import useChangeApprovalQuery from '~/hooks/services/servicenow/queries/useChangeApprovalQuery'
import useChangeAttachmentsQuery from '~/hooks/services/servicenow/queries/useChangeAttachmentsQuery'

import { formatFileSize } from '~/utils/files'

import { useParams } from 'react-router-dom'

import { useApprovalAttachments } from './useAttachments'

const Attachments = () => {
  const { id } = useParams()
  const { data: approval } = useChangeApprovalQuery(id)
  const { data: attachments } = useChangeAttachmentsQuery(approval?.change)

  const { handleDownload, actionedIds } = useApprovalAttachments(approval?.change!)

  return (
    <>
      <div className="flex items-center justify-between">
        <div>Attachments</div>
      </div>

      <div className="mt-6">
        <ul>
          {attachments?.map((attachment) => (
            <li key={attachment.id} className="flex items-center border-b border-th-border py-2 text-sm last:border-b-0">
              <div
                className="group flex flex-auto cursor-pointer justify-between aria-disabled:pointer-events-none aria-disabled:select-none aria-disabled:opacity-50"
                onClick={() => handleDownload(attachment)}
                aria-disabled={actionedIds.includes(attachment.id)}
              >
                <span className="group-hover:underline">{attachment.name}</span>
                <span>{formatFileSize(attachment.size)}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}

export default Attachments
